// extracted by mini-css-extract-plugin
export default {"flex":"GLacrVwTmZUsfPEiaEs0"};